import React, {useState} from 'react';
import cn from 'classnames';
import {useTranslation} from 'next-i18next';
import {HighlightProductItem} from '@/__generated__/__types__';
import {Product} from '@/_application/modules/products/model/product';
import BestSellerProducts from '@/_application/modules/products/components/highlight-products-block/best-seller-products';
import HighlightProducts from '@/_application/modules/products/components/highlight-products-block/highlight-product';
import NewArrivalProducts from '@/_application/modules/products/components/highlight-products-block/new-arrival-products';

// eslint-disable-next-line no-unused-vars
enum TabOptionKeys {
    // eslint-disable-next-line no-unused-vars
    BEST_SELLER = 'BEST_SELLER',
    // eslint-disable-next-line no-unused-vars
    HIGHLIGHT = 'HIGHLIGHT',
    // eslint-disable-next-line no-unused-vars
    NEW = 'NEW',
}

export interface HighlightTabsData {
    highlightProducts: HighlightProductItem[];
    hotNewProducts: Product[];
    bestSellerProducts: Product[];
    bestSellerHighlightProducts: HighlightProductItem[];
    newArrivalProducts: Product[];
}

export interface HighLightTabsProps {
    highlightTabsData?: HighlightTabsData;
}

function HighLightTabs({highlightTabsData}: HighLightTabsProps) {
    const {t} = useTranslation('common');
    const [currentTab, setCurrentTab] = useState<TabOptionKeys>(TabOptionKeys.HIGHLIGHT);
    const tabs = [
        {
            key: TabOptionKeys.HIGHLIGHT,
            title: t('text-popular', 'Nổi bật'),
        },
        {
            key: TabOptionKeys.BEST_SELLER,
            title: t('text-best-seller', 'Bán chạy'),
        },
        {
            key: TabOptionKeys.NEW,
            title: t('text-new', 'Mới về'),
        },
    ];

    return (
        <>
            <div className="flex items-center gap-8">
                {tabs.map(tab => (
                    <button
                        key={tab.key}
                        aria-label="Tab sản phẩm nổi bật"
                        className={cn(
                            'cursor-pointer text-[22px] font-extrabold leading-[25px] transition-colors hover:text-primary',
                            {
                                'text-primary': tab.key === currentTab,
                                'text-KPZ_text_2nd': tab.key !== currentTab,
                            },
                        )}
                        onClick={() => setCurrentTab(tab.key)}>
                        {tab.title}
                    </button>
                ))}
            </div>

            {currentTab === TabOptionKeys.HIGHLIGHT && (
                <HighlightProducts
                    highlightProducts={highlightTabsData?.highlightProducts}
                    hotNewProducts={highlightTabsData?.hotNewProducts}
                />
            )}
            {currentTab === TabOptionKeys.BEST_SELLER && (
                <BestSellerProducts
                    products={highlightTabsData?.bestSellerProducts}
                    highlightProducts={highlightTabsData?.bestSellerHighlightProducts}
                />
            )}
            {currentTab === TabOptionKeys.NEW && (
                <NewArrivalProducts newArrivalProducts={highlightTabsData?.newArrivalProducts} />
            )}
        </>
    );
}

export default HighLightTabs;
